import React, { useState, useRef, useEffect } from "react";
import "../index.css";

const MAX_DIMENSION = 2000; // Max width/height in px
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const UploadImage = ({ onChange }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    // Cleanup object URL when component unmounts or image changes
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please upload a valid image file.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      alert("File is too large. Please choose a file smaller than 5MB.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result;
      const img = new Image();

      img.onload = () => {
        if (img.width > MAX_DIMENSION || img.height > MAX_DIMENSION) {
          const scale = Math.min(
            MAX_DIMENSION / img.width,
            MAX_DIMENSION / img.height
          );
          const newWidth = img.width * scale;
          const newHeight = img.height * scale;

          const canvas = document.createElement("canvas");
          canvas.width = newWidth;
          canvas.height = newHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              const blobUrl = URL.createObjectURL(blob);
              setPreviewUrl(blobUrl);
              onChange(resizedFile);
            }
          }, file.type);
        } else {
          const objectUrl = URL.createObjectURL(file);
          setPreviewUrl(objectUrl);
          onChange(file);
        }
      };

      img.onerror = () => {
        alert("Could not process the image. Please try a different one.");
      };

      img.src = dataUrl;
    };

    reader.onerror = () => {
      alert("Failed to read file.");
    };

    reader.readAsDataURL(file);
  };

  const handleChange = (e) => {
    handleFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div className="flex flex-col items-start gap-4 w-full max-w-md">
      <input
        type="file"
        accept="image/*"
        onChange={handleChange}
        ref={fileInputRef}
        className="hidden"
      />

      <div className="flex items-center gap-4 w-full">
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onClick={() => fileInputRef.current.click()}
          className="flex-1 p-6 border-2 border-dashed border-vedicGold rounded-3xl flex justify-center items-center text-marbleWhite bg-deepSlate hover:border-yellow-400 hover:shadow-gold transition-all cursor-pointer text-sm font-medium text-center min-h-[140px]"
        >
          {previewUrl
            ? "Replace Image"
            : "✨ Drag & Drop an image here or click to select ✨"}
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
